/**
 * The app icon shows only what is still unread (Gary, 20 Oct: the dot stayed, so it always looked as if something
 * needed checking). On a phone the icon's dot is the alerts still in the notification tray, which stayed there after
 * the chat was read in the app; they only went when tapped. Each sync closes the alerts for chats and team chats that
 * no longer need you, and sets the icon's number to what does (where the phone supports it).
 */

// Alerts about one chat or team chat, tagged "<kind>-<id>". Others (a failed invoice, Meta account notices, budget
// warnings, tests) stay until tapped.
const CHAT_TAG = /^(chat|nudge|remind|reminder|mention|busy|drc|drc-warn|unhappy|team)-([0-9a-f-]{36})$/;

/** The chat or team chat an alert is about, or null for alerts that stay until tapped. */
export function alertChat(tag: string): { team: boolean; id: string } | null {
  const m = CHAT_TAG.exec(tag);
  return m ? { team: m[1] === 'team', id: m[2]! } : null;
}

type BadgeNavigator = Navigator & { setAppBadge?: (n?: number) => Promise<void>; clearAppBadge?: () => Promise<void> };

export function syncPhoneAlerts(count: number, needYou: Set<string>, teamLoaded: boolean): void {
  const nav = navigator as BadgeNavigator;
  try {
    void (count > 0 ? nav.setAppBadge?.(count) : nav.clearAppBadge?.())?.catch(() => undefined);
  } catch {
    // No icon badges on this browser.
  }
  if (!('serviceWorker' in navigator)) return;
  void navigator.serviceWorker.getRegistration()
    .then((reg) => reg?.getNotifications() ?? [])
    .then((list) => {
      for (const n of list) {
        const about = alertChat(n.tag);
        // Team chats load a moment after customer chats: their alerts wait until they have.
        if (!about || (about.team && !teamLoaded)) continue;
        if (!needYou.has(about.id)) n.close();
      }
    })
    .catch(() => undefined);
}
